import React from "react";
import { useNavigate } from "react-router-dom";
import UTILS from "../../utils/commons";

const InventoryItem = props => {
    const navigate = useNavigate();
    const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
    const canViewProduct = loginState?.role === UTILS.ADMIN;
    var data = props.data;
    return ( <div className="grid md:grid-cols-6 gap-0 md:justify-start md:items-center bg-white hover:bg-gray-50 cursor-pointer border-t border-gray-100">
        <div className="bg-gray-50 grid col-span-6 md:grid-cols-6 gap-2 md:justify-start md:items-center px-3 py-2 font-medium text-gray-700">
            <div className="col-span-2">
                {canViewProduct ? (
                    <span className="hover:underline cursor-pointer" onClick={() => { navigate( `/products/view/${data?.product?.id}`, { state: data?.product } ) }}>{data?.product?.productName} - {data?.product?.packSize}</span>
                ) : (
                    <span className="text-gray-700 cursor-not-allowed">{data?.product?.productName} - {data?.product?.packSize}</span>
                )}
            </div>
            <div className="col-span-1"></div>
            <div className="">{UTILS.thousandSeparator( data.totalQuantity )}</div>
            <div className="col-span-1">{UTILS.thousandSeparator( data?.totalAvailable )}</div>
            <div className="text-right">{UTILS.thousandSeparator( data?.totalAmount )}</div>
        </div>
        {data.items.map( inv => {
            return <div key={inv.id} className="grid md:grid-cols-6 gap-2 md:col-span-6 px-3 py-2 text-gray-700">
                <div className="">{UTILS.formatDate( inv.createdAt )}</div>
                <div className="text-left">{inv.invoiceNumber}</div>
                <div className="text-left">{UTILS.thousandSeparator( inv.sellingPrice )}</div>
                <div className="text-left">{UTILS.thousandSeparator( inv.stockQuantity )}</div>
                <div className="text-left">{UTILS.thousandSeparator( inv.availableQuantity )}</div>
                <div className="text-right">{UTILS.thousandSeparator( Number( inv.availableQuantity ) * Number( inv.sellingPrice ) )}</div>
                {/* <div className="">{<span className="clickable text-primary" onClick={() => { navigate( "/inventory/" + data.id, { state: data, replace: false } ) }}>{data.invoiceNumber}</span>}</div> */}
            </div>
        } )}

    </div> )
}
export default InventoryItem;
